import { invoke } from '@shared/easyfy.decorators';
import { SocialMediaShare } from '@clientWebModules/socialmedia-share';

@invoke
export default class ArticleList {
  constructor() {
    SocialMediaShare;
  }

  onInit() {}
}
